import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { QueryParamsConst } from '../../../constants/query-params.constants';
import { updateSearchResults } from '../../../hooks/useQueryParams.effect';
import { TBaseObj, TImageField, TSitecoreContext } from '../../../types/sitecore.types';
import { TNewsListingFields, TNewsListingFilter, TNewsListingItem, TNewsListingProps } from '../types/newsListing.types';

export class NewsListingItemModel {
  private readonly newsItem?: TNewsListingItem;
  private readonly context: TSitecoreContext | undefined;

  constructor(props: TNewsListingItem) {
    this.newsItem = props;
    this.context = props?.sitecoreContext;
  }

  get desktopImage(): TImageField | undefined {
    return this.newsItem?.Image;
  }

  get mobileImage(): TImageField | undefined {
    return this.newsItem?.MobileImage;
  }

  get defaultBgDesktopImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.desktopImageData?.newsListing,
      },
    };
  }

  get defaultBgMobileImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.mobileImageData?.newsListing,
      },
    };
  }

  get tag(): string | undefined {
    return this.newsItem?.tagCategories?.[0]?.name;
  }

  get newsDate(): string | undefined {
    return this.newsItem?.newsDate;
  }

  get title(): string | undefined {
    return this.newsItem?.title;
  }

  get shortDescription(): string | undefined {
    return this.newsItem?.shortDescription;
  }

  get useVideo(): boolean {
    return this.newsItem?.useVideo === '1';
  }

  get video(): string | undefined {
    return this.newsItem?.video;
  }

  get ctaLink(): string | undefined {
    return this.newsItem?.link;
  }
}

export class NewsListingModel {
  private readonly fields?: TNewsListingFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TNewsListingProps) {
    this.fields = props.fields;
    this.rendering = props?.rendering;
  }

  get filters(): TNewsListingFilter[] {
    return this.fields?.apiData?.filters || [];
  }

  get items(): TNewsListingItem[] {
    return this.fields?.apiData?.items || [];
  }

  findFilterByName(filterName: string): TNewsListingFilter {
    return this?.filters.find((filter) => filter.value === filterName) || {};
  }

  resetFilter(navigate) {
    updateSearchResults(navigate, {
      [QueryParamsConst.PAGE]: '',
      [QueryParamsConst.YEAR]: '',
      [QueryParamsConst.LINE]: '',
      [QueryParamsConst.TYPE]: '',
      [QueryParamsConst.INDUSTRY]: '',
    });
  }

  updateQueryByKey(navigate, key, val) {
    const resetPage = key != QueryParamsConst.PAGE;

    const keyValues = resetPage
      ? {
          [QueryParamsConst.PAGE]: '',
          [key]: val || '',
        }
      : {
          [key]: val || '',
        };

    updateSearchResults(navigate, keyValues);
  }

  updateQueryByBulkKeys(navigate, obj: TBaseObj) {
    updateSearchResults(navigate, obj);
  }

  get counter(): number {
    return this.fields?.apiData?.totalSearchResults || 0;
  }

  get contextItemUrl(): string {
    return this.fields?.itemData?.contextItemUrl || '';
  }

  get isUnreleased(): boolean | undefined {
    return !!this.fields?.isComponentUnreleased;
  }

  get defaultCardImage(): TImageField | undefined {
    return this.fields?.itemData?.fields?.defaultCardImage;
  }

  get placeholderImageSrc(): string | undefined {
    return this.fields?.itemData?.thumbnail;
  }
}
